/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { connect } from "react-redux";
import { Table, Popover, Divider } from "antd";
import { AuditOutlined, PlayCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { abrirAtendimento } from "../service";
import { useNavigate } from "react-router-dom";
import { PERFIS } from "Misc/constants";

const MeusPacientesTabela = ({ pacientesPlano, user }) => {
  const navigate = useNavigate();

  const handleClick = async (id) => {
    const res = await abrirAtendimento(id);

    navigate(`/atendimento/7/${res.data.idTarefa}`);
  };

  const columns = [
    {
      title: "Nome do Paciente",
      dataIndex: "nomePaciente",
      key: "nomePaciente",
    },
    {
      title: "Telefone",
      dataIndex: "telefonePrincipal",
      key: "telefonePrincipal",
    },
    {
      title: "Cuidador Principal",
      dataIndex: "nomeCuidador",
      key: "nomeCuidador",
    },
    {
      title: "Telefone Cuidador",
      dataIndex: "telefoneCuidador",
      key: "telefoneCuidador",
    },
    {
      title: "Data/Hora (última ligação periódica)",
      dataIndex: "ultimaLigacao",
      key: "ultimaLigacao",
    },
    {
      title: "Ações",
      dataIndex: "acoes",
      key: "acoes",
      render: (i, record) => (
        <Popover
          placement="right"
          content={
            <>
              <span
                className="popover-menu-item"
                onClick={() => navigate(`/pacientes/${record.idPaciente}`)}
              >
                <AuditOutlined style={{ color: "#0F79B2" }} /> Consultar dados
              </span>
              {user.perfil === PERFIS.ENFERMEIRO_VIVER && (
                <>
                  {" "}
                  <Divider style={{ margin: 4 }} />
                  <span
                    className="popover-menu-item"
                    onClick={() => handleClick(record.idPaciente)}
                  >
                    <PlayCircleOutlined style={{ color: "#138183" }} /> Iniciar atendimento solicitado
                  </span>
                </>
              )}
            </>
          }
        >
          <MoreOutlined className="icon-more" />
        </Popover>
      ),
    },
  ];
  return <Table columns={columns} dataSource={pacientesPlano} size="small" />;
};

const mapStateToProps = (store) => ({
  pacientesPlano: store.meuspacientes.pacientesPlano?.pacientes,
  user: store.login.user,
});

export default connect(mapStateToProps)(MeusPacientesTabela);
